module.exports = __webpack_public_path__ + "assets/playkids-logo-white.8cf7768c.svg";